<nz-tag *ngIf="showDown || getStatusLabel(status)" [nzColor]="tagColor || getStatusColor(status)" [class]="showDown ? 'tag-container' : ''">
    <div>
        {{ getStatusLabel(status) }}
    </div>
    <div>
        <i nz-icon nzType="down" nzTheme="outline" class="down" *ngIf="showDown"></i>
    </div>
</nz-tag>
